var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Your Lists")]),_c('Checklists',{attrs:{"token":_vm.$store.getters.getUserToken,"userSlug":this.$store.getters.getUserUserSlug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }